import { colors } from "widgets/utils";

import { TrackEnum } from "../openapi.ts";
import type { TrackType } from "../types.ts";

export const getColorByTrackType = (trackType: TrackType): string => {
  return ColorByTrackType[trackType] ?? colors.fadedOrangeLight;
};

export const ColorByTrackType: Partial<Record<TrackType, string>> = {
  [TrackEnum.PROTEIN_LOCATION]: colors.dangerPale,
  [TrackEnum.GENE]: colors.paleTealLight,
  [TrackEnum.TRANSCRIPT_LOCATION]: colors.blueBerryLight,
  [TrackEnum.NUCLEOTIDE_FEATURE]: colors.fadedOrangeLight,
};
